import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { Badge, Box, Tab, Tabs } from '@mui/material';
import {
  GroupsOutlined as TeamsIcon,
  PeopleOutlined as UsersIcon,
  FeedbackOutlined as FeedbackIcon,
  ExtensionOutlined as IntegrationsIcon,
  WidgetsOutlined as CatalogIcon,
  TerminalOutlined as LogsIcon,
  AutoAwesomeOutlined as LessonsIcon,
} from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { agentLessonsApi } from '@/services/api';

const TAB_PATHS = [
  { label: 'Teams & Approvals', path: 'teams', icon: <TeamsIcon /> },
  { label: 'Users & Access', path: 'users', icon: <UsersIcon /> },
  { label: 'Feedback', path: 'feedback', icon: <FeedbackIcon /> },
  { label: 'Integrations', path: 'integrations', icon: <IntegrationsIcon /> },
  { label: 'Skills & Plugins', path: 'catalog', icon: <CatalogIcon /> },
  { label: 'Agent Lessons', path: 'lessons', icon: <LessonsIcon /> },
  { label: 'Logs', path: 'logs', icon: <LogsIcon /> },
];

export default function AdminHubPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const { data: lessons = [] } = useQuery({
    queryKey: ['admin', 'agent-lessons'],
    queryFn: () => agentLessonsApi.list().then((r) => r.data),
    staleTime: 30_000,
  });
  const pendingCount = lessons.filter((l) => !l.approved).length;

  const currentPath = location.pathname.split('/').pop() || 'teams';
  const activeTabIndex = Math.max(
    0,
    TAB_PATHS.findIndex((tab) => tab.path === currentPath),
  );

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    const tab = TAB_PATHS[newValue];
    if (tab) {
      navigate(`/admin/${tab.path}`);
    }
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={activeTabIndex}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {TAB_PATHS.map((tab) => {
            const isPendingLessonsTab = tab.path === 'lessons' && pendingCount > 0;
            const tabLabel = isPendingLessonsTab ? (
              <Badge badgeContent={pendingCount} color="warning" sx={{ pr: 1 }}>
                {tab.label}
              </Badge>
            ) : (
              tab.label
            );
            return (
              <Tab
                key={tab.path}
                label={tabLabel}
                icon={tab.icon}
                iconPosition="start"
                sx={{ fontSize: '0.82rem', minHeight: 42, py: 0.5, '& .MuiTab-iconWrapper': { fontSize: 18 } }}
              />
            );
          })}
        </Tabs>
      </Box>

      <Outlet />
    </Box>
  );
}
